import './clip-tray.scss';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ClipType } from 'types';
import Card from '../card';
import moment from 'moment';
import ListingReport from './listing-report';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../types/root';
import { actions } from 'redux/reducers';
import Loader from './loader';

function ClipTray({
    onRate,
} : {
    onRate?: any
}) {
    const ref = useRef<any>();
    const dispatch = useDispatch();
    const { open, clips, loading } = useSelector((state: RootState) => state.clipTray);
    const [data, setData] = useState<ClipType[]>([]);
    const [page, setPage] = useState<number>(1);
    const [expanded, setExpanded] = useState<boolean>(false);
    const [showListingReport, setShowListingReport] = useState<boolean>(false);

    const loadMore = () => {
        setPage(page + 1);
    }

    const close = useCallback(() => {
        dispatch(actions.clipTray.set({
            open: false,
            clips: []
        }))
        setExpanded(false);
        setPage(1);
        setShowListingReport(false);
    }, [dispatch])

    const expand = (e: React.MouseEvent) => {
        e.stopPropagation();
        setExpanded(true);
    }

    const compress = (e: React.MouseEvent) => {
        e.stopPropagation();
        setExpanded(false); 
        setShowListingReport(false);
    }

    useEffect(() => {
        setPage(1);
        setData(clips);
    }, [clips])

    useEffect(() => {
        setData(clips.slice(0, 10 * page));
    }, [clips, page])

    useEffect(() => {
        function handleClick(e: MouseEvent) {
            if (ref.current && !ref.current.contains(e.target)) {
                close();
            }
        }
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [close])

    return (
        <div className={`clip-tray ${expanded ? 'expanded' : ''} ${open ? 'open' : ''}`} ref={ref}>
            <div className="top">
                <i className="fal fa-times" onClick={close}></i>
                <p>Posts</p>
                {expanded && <i className={`fal fa-${showListingReport ? 'th' : 'list'}`} onClick={() => setShowListingReport(!showListingReport)}></i>}
                {expanded && <i className='fal fa-compress' onClick={compress}></i>}
                {!expanded && <i className='fal fa-expand' onClick={expand}></i>}
            </div>
            <div className="body" style={loading ? { overflow: 'hidden' } : { overflow: 'auto' }}>
                {loading && <Loader />}
                {!showListingReport && !loading && data.map((x: ClipType, i: number) => {
                    return (
                        <Card 
                            key={i}
                            authorName={x.AuthorName} 
                            body={x.Body} 
                            datePosted={moment(x.DatePosted)} 
                            streamId={x.StreamId} 
                            impactScore={x.ImpactScore}
                            ave={x.AVE}
                            link={x.Link}
                        />
                    )
                })}
                {showListingReport && expanded && (
                    <ListingReport clips={clips} onRate={onRate} />
                )}
                {(!showListingReport && data.length !== clips.length && data.length % 10 === 0) && <button onClick={loadMore}>Load More</button>}
            </div>
        </div>
    )
}

export default ClipTray;